import React, {
  AnchorHTMLAttributes,
  ButtonHTMLAttributes,
  forwardRef,
  ForwardRefRenderFunction
} from 'react'
import * as S from './styles'

type ButtonTypes =
  | AnchorHTMLAttributes<HTMLAnchorElement>
  | ButtonHTMLAttributes<HTMLButtonElement>

export type ButtonProps = {
  label?: string
  as?: React.ElementType
} & ButtonTypes

const FavoriteButton: ForwardRefRenderFunction<S.WrapperProps, ButtonProps> = (
  { label = '⭐ Favoritar Procedimento', ...props }: ButtonProps,
  ref
) => (
  <S.Button ref={ref} {...props}>
    <p>{label}</p>
  </S.Button>
)

export default forwardRef(FavoriteButton)
